import {FireInTheHole2} from "../../FireInTheHole2";
import {gsap} from "gsap";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {IFsSymbolData} from "../../symbols/freespin/FreespinSymbol";
import {ChestSymbol} from "../../symbols/freespin/ChestSymbol";
import {FITH2SoundManager} from "../../sound/FITH2SoundManager";

export class ChestCollectPresentation implements FlowStatePresentation {
    name: string = "FreeSpinNoWinPause";

    shouldRun(): boolean {
        return FireInTheHole2.model.hasChestOpen;
    }

    start(controller: FlowStateController): void {
        const tl = gsap.timeline(),
            fastSpin:boolean = FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN),
        valueDropStartTime:number = fastSpin?0.1:0.2,
        delay:number = fastSpin?0:0.5;
        let collectId: number = 0;
        FireInTheHole2.model.gameData.evaluatedArea.forEach((reel: string[], i: number) => {
            if (reel[5] === "CO") {

                let hasValueToCollect: boolean = false;
                for (let j: number = 1; j < 5; j++) {
                    hasValueToCollect = ((reel[j] == "D" || reel[j] == "M") ? hasValueToCollect : true);
                    tl.add(FireInTheHole2.freespinReelArea.chestCollectAnimation(i, j), collectId * delay+valueDropStartTime);
                }
                if (hasValueToCollect) {
                    tl.add(()=>{FITH2SoundManager.playSound("fsCoinSweep")}, collectId * delay+valueDropStartTime);
                    tl.add(()=>{FITH2SoundManager.playSound("fsMultiDownToChest")}, collectId *delay);
                    tl.add(FireInTheHole2.chestRow.getChest(i).collectStart(), collectId * delay+valueDropStartTime);
                    tl.add(()=>{
                        FireInTheHole2.chestRow.getChest(i).collect()
                    }, collectId * delay + 0.8+ valueDropStartTime);
                }
                collectId += (hasValueToCollect ? 1 : 0);
            }
        });
        tl.add(() => {
            controller.finish();
        }, collectId>0?(collectId * delay+0.8):0.01);
    }
}